'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$() {
}
export { $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$ as $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$ };
$p = $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$;
/** @constructor */
function $h_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$() {
}
export { $h_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$ as $h_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$ };
$h_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$.prototype = $p;
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$, "app.data.organization_types$package$OrganizationCopyDocumentWatermark$", ({
  GO: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$ as $d_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$ };
var $n_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$;
function $m_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$() {
  if ((!$n_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$)) {
    $n_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$ = new $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$();
  }
  return $n_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$;
}
export { $m_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$ as $m_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$ };
//# sourceMappingURL=app.data.organization_types$package$-Organization-Copy-Document-Watermark$.js.map
